module.exports = __webpack_public_path__ + "static/media/pixelated-sofa.4df4e26c.png";